module.exports = __webpack_public_path__ + "img/govcoll.7810c45c.jpg";